import Cookie from 'js-cookie';
import get from 'lodash/get';
import { detect } from 'detect-browser';
import KM from '@ott/utility-km';
import getUserInfoOnce from './getUserInfoOnce';

let browser;

const pageView = function(page, params = {}) {
  if (!browser) {
    browser = detect();
  }

  return (dispatch, getState) => {
    dispatch(getUserInfoOnce()).finally(() => {
      const {
        common: { auth },
      } = getState();

      KM('PageView', {
        obj: {
          ...params,
          page,
          vid: Cookie.get('vid'),
          browserVersion: browser && browser.version,
          browserModel: browser && browser.name,
          referrer: Cookie.get('referrer') || '',
          referrer_mrk: Cookie.get('referrer_mrk') || '',
          abst: Cookie.get('abst'),
          Envid: Cookie.get('ENVID'),
          url: window.location.pathname,
          is_auth: get(auth, 'data.auth', false),
          ts: Date.now(),
        },
      });
    });
  };
};

export default pageView;
